import React from 'react';
import events from 'lib/events';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import Modal from './modal.jsx';

class FirmwareUpdateModal extends React.PureComponent {
  static displayName = 'FirmwareUpdateModal';

  constructor(props) {
    super(props);
    this.showListener = events.subscribe('scanpage.displayModal', (show) => this.setState({
      visible: show,
    }));
  }

  state = {
    visible: true,
  };

  close = () => {
    this.setState({
      visible: false,
    });
  };

  render() {

    if(!this.state.visible) {
      return null;
    } else {
      return <Modal
      className='firmware-modal'
      onClose={this.close}
      headerText={<FormattedMessage id='error.scanner.update.header'/>}
    >
        <div>
          <p className='firmware-modal-message1'><FormattedMessage id='error.scanner.update.body'/></p>
          <p className='firmware-modal-message2'><FormattedHTMLMessage id='error.scanner.update.body21'/> <a href='tel:1-800-859-7946'>1-800-859-7946</a><FormattedHTMLMessage id='error.scanner.update.body22'/></p>
          <button className='btn btn-primary firmware-modal-button' onClick={this.close}><FormattedMessage id='error.scanner.update.dismiss'/></button>
        </div>
      </Modal>;
    }
  }
}

export default FirmwareUpdateModal;